export function createModule (platform, { capturedGet, capturedPost, capturedPut, capturedRemove } = {}) {
  const state = {}
  const getters = {}
  const mutations = {}
  const actions = {
    async getAdUsers (context) {
      return capturedGet(`/${platform}/ads/ad/adselect`)
    },
    async getChannels (context, { params }) {
      return capturedGet(`/${platform}/apps-channel`, params)
    },
    async addAndUpdateChannel (context, { type, id, params }) {
      const requestMethod = type === 'edit' ? capturedPut : capturedPost
      return requestMethod(`/${platform}/apps-channel${ type === 'edit' ? '/' + id : '' }`, params)
    },
    async removeChannel (context, { id }) {
      return capturedRemove(`/${platform}/apps-channel/${id}`)
    },
    async getChannelDetail (context, { id }) {
      return capturedGet(`/${platform}/apps-channel/${id}`)
    },
    async getSelectData (context) {
      return capturedGet(`/${platform}/apps-channel/selectlist`)
    },
    async uploadApk (context, { formData, config }) {
      return capturedPost(`/${platform}/apps-channel/apk-upload`, formData, config)
    },
    async uploadIcon (context, formData) {
      return capturedPost(`/${platform}/apps-channel/icon-upload`, formData)
    },
    async getChannelByAdId (context, id) {
      return capturedGet(`/${platform}/apps-channel/apps-select`, { advertiser_id: id })
    }
  }

  return {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }
}
